import { Badge, Button, Checkbox, Col, ConfigProvider, DatePicker, Divider, Flex, Popover, Radio, Select, Space, Tag } from "antd";
import { CardContainer } from "components/elements";
import {
  EditOutlined,
  LeftOutlined,
  RightOutlined,
} from "@ant-design/icons";
import styles from "../styles/EmployeeWorkinCalendar.module.css";
import thTH from "antd/es/calendar/locale/th_TH";
import enUS from "antd/es/calendar/locale/en_US";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { ReactComponent as LeftArrowIcon } from "assets/icon/leftArrowIcon.svg";
import { ReactComponent as RightArrowIcon } from "assets/icon/rightArrowIcon.svg";
import FullCalendar from "@fullcalendar/react";
import timeGridPlugin from '@fullcalendar/timegrid'
import { useCallback, useEffect, useMemo, useState } from "react";
import { Calendar, dayjsLocalizer, Views } from "react-big-calendar";
import dayjs from 'dayjs'
import "react-big-calendar/lib/css/react-big-calendar.css";
import localeTh from 'antd/es/date-picker/locale/th_TH';
import localeEn from 'antd/es/date-picker/locale/en_US';
import { useSelector } from "react-redux";
import SupervisorRequestOtModal from "./SupervisorRequestOtModal";
import EmployeeWorkinDetailModal from "./EmployeeWorkinDetailModal";
import StatusTag from "components/elements/TagCustom/StatusTag";
import useMyTeamCalendar from "features/myTeam/hooks/useMyTeamCalendar";

function EmployeeWorkInCalendar({
  onChange = () => { },
  cellRender = () => { },
  footerTag = () => { },
  employeeFormMenu = {},
  employeeList = () => { },
  transformCalendar = [],
  getWorkInCalendar = () => { },
  statusColor = [],
  employeeTeam = null,
  employeeName = null,
  isUpdateMode = false,
  setIsUpdateMode = () => { },
  onSubmitSupRequest = () => { },
  isModalOpen = false,
  setIsModalOpen = () => { },
  workTypeOptions = [],
  onAttachFileChange = () => { },
  setpreviousFilew = () => { },
  setEmployeeTeam = () => { },
  onSubmitOffSiteWork = () => { },
  onSubmitLeave = () => { },
  leaveGroupOptions = [],
  editTimeAtt = () => { },
  onSubmitEditWorkTime = () => { },
  isLeaveDetailModalOpen = false,
  setIsLeaveDetailModalOpen = () => { },
  requestList = () => { },
  isEmployee = false,
  getCalendarRange = () => { }
}) {
  const { t, i18n } = useTranslation();
  const localizer = dayjsLocalizer(dayjs)
  const [view, setView] = useState(Views.MONTH);
  const [date, setDate] = useState(new Date());
  const { calendar } = useSelector((state) => state.employee);
  // const [isOtModalOpen, setIsOtModalOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [selectedShift, setSelectedShift] = useState(null);
  const [selectedWorkInTime, setSelectedWorkInTime] = useState({ workInStart: null, workInEnd: null });
  const [selectedOtTime, setSelectedOtTime] = useState({ otTimeStart: null, otTimeEnd: null });
  const currentCompanyProfile = useSelector((state) => state.company.currentCompanyProfile);
  const [popoverVisible, setPopoverVisible] = useState({});
  const [selectRequest, setSelectRequest] = useState([]);
  const { roles } = useSelector((state) => state.company);
  const { isHrView, handleHrViewChange } = useMyTeamCalendar();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  const handleViewDateChange = () => {
    setView(Views.MONTH);
  };

  useMemo(() => employeeTeam && setEmployeeTeam(employeeTeam), [employeeTeam, setEmployeeTeam])

  const startOfWeek = dayjs(date).startOf("week");
  const endOfWeek = dayjs(date).endOf("week");
  const formattedWeek =
    `${startOfWeek.format("D")} - ${endOfWeek.format("D MMMM")}`;

  function localeFn() {
    if (i18n.language === 'en') {
      return localeEn
    } else {
      return {
        ...localeTh,
        lang: {
          ...localeTh.lang,
          yearFormat: "BBBB",
          dateFormat: "D/M/BBBB",
          cellYearFormat: "BBBB"
        }
      }
    }
  }

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const onPrevClick = useCallback(() => {
    const newDate = view === Views.WEEK
      ? dayjs(date).subtract(1, "week").toDate()
      : dayjs(date).subtract(1, "month").toDate();

    setDate(newDate);

    if (view === Views.WEEK) {
      const startDate = dayjs(newDate).startOf("week").format("YYYY-MM-DD");
      const endDate = dayjs(newDate).endOf("week").format("YYYY-MM-DD");

      getWorkInCalendar(startDate, endDate, employeeTeam);
    } else {
      const range = getCalendarRange(dayjs(newDate));

      getWorkInCalendar(range.start, range.end, employeeTeam);
    }

    onChange(dayjs(newDate), employeeTeam);
  }, [view, date, getWorkInCalendar, employeeTeam, onChange]);

  const onNextClick = useCallback(() => {
    const newDate = view === Views.WEEK
      ? dayjs(date).add(1, "week").toDate()
      : dayjs(date).add(1, "month").toDate();

    setDate(newDate);

    if (view === Views.WEEK) {
      const startDate = dayjs(newDate).startOf("week").format("YYYY-MM-DD");
      const endDate = dayjs(newDate).endOf("week").format("YYYY-MM-DD");

      getWorkInCalendar(startDate, endDate, employeeTeam);
    } else {
      const range = getCalendarRange(dayjs(newDate));

      getWorkInCalendar(range.start, range.end, employeeTeam);
    }

    onChange(dayjs(newDate), employeeTeam);
  }, [view, date, getWorkInCalendar, onChange, employeeTeam]);

  const handleViewChange = useCallback((e) => {
    const newView = e.target.value;
    setView(newView);

    const startDate = newView === Views.WEEK
      ? dayjs(date).startOf("week").format("YYYY-MM-DD")
      : dayjs(date).startOf("month").format("YYYY-MM-DD");

    const endDate = newView === Views.WEEK
      ? dayjs(date).endOf("week").format("YYYY-MM-DD")
      : dayjs(date).endOf("month").format("YYYY-MM-DD");

    getWorkInCalendar(startDate, endDate, employeeTeam?.employeeTeam);
  }, [date, getWorkInCalendar]);

  const handleDateChange = (value) => {
    if (!value) return;

    let newDate;
    if (view === Views.WEEK) {
      newDate = dayjs(value).startOf("week").toDate();
    } else {
      newDate = dayjs(value).startOf("month").toDate();
    }
    setDate(newDate);

    const startDate = view === Views.WEEK
      ? dayjs(newDate).startOf("week").format("YYYY-MM-DD")
      : dayjs(newDate).startOf("month").format("YYYY-MM-DD");

    const endDate = view === Views.WEEK
      ? dayjs(newDate).endOf("week").format("YYYY-MM-DD")
      : dayjs(newDate).endOf("month").format("YYYY-MM-DD");

    getWorkInCalendar(startDate, endDate, employeeTeam);

    onChange(dayjs(newDate), employeeTeam);
  };

  const handleTodayClick = useCallback(() => {
    const today = new Date();
    setDate(today);

    const startDate = view === Views.WEEK
      ? dayjs(today).startOf("week").format("YYYY-MM-DD")
      : dayjs(today).startOf("month").format("YYYY-MM-DD");

    const endDate = view === Views.WEEK
      ? dayjs(today).endOf("week").format("YYYY-MM-DD")
      : dayjs(today).endOf("month").format("YYYY-MM-DD");

    getWorkInCalendar(startDate, endDate, employeeTeam?.employeeTeam);

    onChange(dayjs(today), employeeTeam);
  }, [view, getWorkInCalendar, onChange, employeeTeam?.employeeTeam]);

  const handleEditIconClick = useCallback((formattedDate, e) => {
    e.stopPropagation();

    const dayData = calendar?.find(o =>
      dayjs(o?.date).format('YYYY-MM-DD') === formattedDate
    );

    const eventForDate = transformCalendar.find(event =>
      dayjs(event.start).format('YYYY-MM-DD') === formattedDate
    );

    const shiftNameFromDayData = i18n.language === "en" ? dayData?.shiftNameEn : dayData?.shiftName;
    const shiftNameFromEvent = i18n.language === "en" ? eventForDate?.shiftNameEn : eventForDate?.shiftName;

    const checkIn = eventForDate?.checkInTime || dayData?.checkInTime || null;
    const checkOut = eventForDate?.checkOutTime || dayData?.checkOutTime || null;

    const workIn = eventForDate?.workInStart || dayData?.workInStart || null;
    const workOut = eventForDate?.workInEnd || dayData?.workInEnd || null;

    let finalStart = null;
    let finalEnd = null;

    if (checkIn && !checkOut) {
      finalStart = checkIn;
      finalEnd = null;
    } else if (!checkIn && !checkOut) {
      finalStart = workIn ? `${formattedDate}T${workIn}:00` : null;
      finalEnd = workOut ? `${formattedDate}T${workOut}:00` : null;
    } else {
      finalStart = checkIn;
      finalEnd = checkOut;
    }

    setSelectedDate(formattedDate);
    setSelectedEmployee(employeeTeam);
    setSelectedShift(shiftNameFromDayData || shiftNameFromEvent || null);

    setSelectedWorkInTime({
      workInStart: finalStart,
      workInEnd: finalEnd
    });

    setSelectedOtTime({
      otTimeStart: eventForDate?.otTimeStart,
      otTimeEnd: eventForDate?.otTimeEnd,
    })

    setIsModalOpen(true);
  }, [calendar, transformCalendar, employeeTeam, i18n.language]);

  const handleSelectSlot = useCallback(({ start }) => {
    if (!isUpdateMode) return;

    const formattedDate = dayjs(start).format("YYYY-MM-DD");

    const dayData = calendar?.find(o =>
      dayjs(o?.date).format('YYYY-MM-DD') === formattedDate
    );

    const eventForDate = transformCalendar.find(event =>
      dayjs(event.start).format('YYYY-MM-DD') === formattedDate
    );

    const shiftNameFromDayData = i18n.language === "en" ? dayData?.shiftNameEn : dayData?.shiftName;
    const shiftNameFromEvent = i18n.language === "en" ? eventForDate?.shiftNameEn : eventForDate?.shiftName;

    const checkIn = eventForDate?.checkInTime || dayData?.checkInTime || null;
    const checkOut = eventForDate?.checkOutTime || dayData?.checkOutTime || null;

    const workIn = eventForDate?.workInStart || dayData?.workInStart || null;
    const workOut = eventForDate?.workInEnd || dayData?.workInEnd || null;

    let finalStart = null;
    let finalEnd = null;

    if (checkIn && !checkOut) {
      finalStart = checkIn;
      finalEnd = null;

    } else if (!checkIn && !checkOut) {
      finalStart = workIn ? `${formattedDate}T${workIn}:00` : null;
      finalEnd = workOut ? `${formattedDate}T${workOut}:00` : null;

    } else {
      finalStart = checkIn;
      finalEnd = checkOut;
    }

    setSelectedDate(formattedDate);
    setSelectedEmployee(employeeTeam);
    setSelectedShift(shiftNameFromDayData || shiftNameFromEvent || null);

    setSelectedWorkInTime({
      workInStart: finalStart,
      workInEnd: finalEnd
    });

    setIsModalOpen(true);
  }, [isUpdateMode, employeeTeam]);

  const handleSelectEvent = useCallback((event) => {
    const clickableEventTypes = ['leave', 'leavePending', 'overtime', 'overtimePending', 'offsite', 'offsitePending'];

    if (clickableEventTypes.includes(event.eventType)) {
      const formattedDate = dayjs(event.start).format("YYYY-MM-DD");

      const dayData = calendar?.find(o =>
        dayjs(o?.date).format('YYYY-MM-DD') === formattedDate
      );

      const eventForDate = transformCalendar.find(e =>
        dayjs(e.start).format('YYYY-MM-DD') === formattedDate
      );

      const shiftNameFromDayData = i18n.language === "en" ? dayData?.shiftNameEn : dayData?.shiftName;
      const shiftNameFromEvent = i18n.language === "en" ? eventForDate?.shiftNameEn : eventForDate?.shiftName;

      const checkIn = eventForDate?.checkInTime || dayData?.checkInTime || null;
      const checkOut = eventForDate?.checkOutTime || dayData?.checkOutTime || null;

      const workIn = eventForDate?.workInStart || dayData?.workInStart || null;
      const workOut = eventForDate?.workInEnd || dayData?.workInEnd || null;

      let finalStart = null;
      let finalEnd = null;

      if (checkIn && !checkOut) {
        finalStart = checkIn;
        finalEnd = null;
      } else if (!checkIn && !checkOut) {
        finalStart = workIn ? `${formattedDate}T${workIn}:00` : null;
        finalEnd = workOut ? `${formattedDate}T${workOut}:00` : null;
      } else {
        finalStart = checkIn;
        finalEnd = checkOut;
      }

      setSelectedDate(formattedDate);
      setSelectedEmployee(employeeTeam);
      setSelectedShift(shiftNameFromDayData || shiftNameFromEvent || null);

      setSelectedWorkInTime({
        workInStart: finalStart,
        workInEnd: finalEnd
      });

      // เปิด Popover โดยการเก็บ eventId
      const eventId = `${event.eventType}-${formattedDate}`;
      setPopoverVisible(prev => ({
        ...prev,
        [eventId]: true
      }));
    }

    if (event.eventType === 'seeMore') {
      const formattedDate = dayjs(event.start).format("YYYY-MM-DD");

      const dayData = calendar?.find(o =>
        dayjs(o?.date).format('YYYY-MM-DD') === formattedDate
      );

      if (!dayData) {
        setSelectRequest([]);
        setIsLeaveDetailModalOpen(true);
        return;
      }

      const requestsForDay = requestList(dayData, i18n);

      setSelectedDate(formattedDate);
      setSelectedEmployee(employeeTeam);
      setSelectedShift(
        i18n.language === "en"
          ? dayData?.shiftNameEn
          : dayData?.shiftName
      );

      setSelectedWorkInTime({
        workInStart: dayData?.workInDateStart ? `${formattedDate}T${dayData.workInDateStart}:00` : null,
        workInEnd: dayData?.workInDateEnd ? `${formattedDate}T${dayData.workInDateEnd}:00` : null
      });

      setSelectRequest(requestsForDay);
      setIsLeaveDetailModalOpen(true);
    }
  }, [calendar, transformCalendar, i18n.language, employeeTeam, setIsLeaveDetailModalOpen]);

  const handleOtModalClose = useCallback(() => {
    setIsModalOpen(false);
    setSelectedDate(null);
    setSelectedEmployee(null);
  }, [setIsModalOpen]);

  const handleOtModalSubmit = useCallback((e) => {
    onSubmitSupRequest({ employeeId: employeeTeam, employeeTeam, ...e });
    handleOtModalClose();
  }, [onSubmitSupRequest, handleOtModalClose, employeeTeam]);

  const handleOffSiteModalSubmit = useCallback((e) => {
    onSubmitOffSiteWork({ employeeId: employeeTeam, employeeTeam, ...e });
    setIsModalOpen(false);
    setSelectedDate(null);
  }, [employeeTeam, onSubmitOffSiteWork, setIsModalOpen])

  const handleLeaveModalSubmit = useCallback((e) => {
    onSubmitLeave({ employeeId: employeeTeam, employeeTeam, ...e });
    setIsModalOpen(false);
    setSelectedDate(null);
  }, [employeeTeam, onSubmitLeave, setIsModalOpen])

  const handleEditWorkTimeModalSubmit = useCallback((e) => {
    onSubmitEditWorkTime({ employeeId: employeeTeam, employeeTeam, ...e });
    setIsModalOpen(false);
    setSelectedDate(null);
  }, [employeeTeam, onSubmitEditWorkTime, setIsModalOpen])

  const processedEvents = useMemo(() => {
    console.log("transformCalendar", transformCalendar);

    return transformCalendar.map(event => {
      const processedEvent = { ...event };

      if (event.dynamicAllDay) {
        if (view === Views.MONTH) {
          processedEvent.start = new Date(`${dayjs(event.start).format('YYYY-MM-DD')}T00:00:00`);
          processedEvent.end = new Date(`${dayjs(event.start).format('YYYY-MM-DD')}T23:59:59`);
          processedEvent.allDay = true;
        } else {
          if (event.workInStart) {
            processedEvent.start = new Date(`${dayjs(event.start).format('YYYY-MM-DD')}T${event.workInStart}`);
            processedEvent.end = new Date(`${dayjs(event.start).format('YYYY-MM-DD')}T${event.workInEnd}`);
          } else if (event.actualCheckIn) {
            processedEvent.start = new Date(event.actualCheckIn);
            processedEvent.end = new Date(event.actualCheckOut);
          }
          processedEvent.allDay = false;
        }
      }

      return processedEvent;
    });
  }, [transformCalendar, view]);

  const dayPropGetter = useCallback((date) => {
    const formattedDate = dayjs(date).format("YYYY-MM-DD");
    const dayData = calendar?.find(o =>
      dayjs(o?.date).format('YYYY-MM-DD') === formattedDate
    );

    const isHoliday =
      (dayData?.statusEn === "Day Off" || dayData?.holidayName) && (!dayData?.works || dayData?.works.length === 0);

    if (isHoliday) {
      return {
        style: {
          backgroundColor: '#F6F6F6',
          position: 'relative'
        }
      };
    }
    // if (isUpdateMode) {
    //   return {
    //     style: {
    //       cursor: 'pointer',
    //       position: 'relative'
    //     }
    //   };
    // }
    return {
      style: {
        position: 'relative'
      }
    };
  }, [calendar]);

  const eventPropGetter = useCallback((event) => {
    const clickableEventTypes = ['leave', 'leavePending', 'overtime', 'overtimePending', 'offsite', 'offsitePending', 'seeMore'];
    const baseStyle = {
      cursor: clickableEventTypes.includes(event.eventType) ? 'pointer' : 'default'
    };

    if (event.eventType === "normalShift") {
      return {
        style: {
          ...baseStyle,
          backgroundColor: "#E6F3FF",
          color: "#0085FF",
        }
      };
    }

    if (event.eventType === "dayOff" || event.eventType === "holiday") {
      return {
        style: {
          ...baseStyle,
          backgroundColor: "#E8E8E8",
          color: "#585757",
        }
      };
    }

    if (event.eventType === "overtimePending" || event.eventType === "offsitePending" || event.eventType === "leavePending") {
      return {
        style: {
          ...baseStyle,
          backgroundColor: "#FFF8E0",
          color: "#FFBF1A",
        }
      };
    }

    if (event.eventType === "normal"
      || event.eventType === "absent"
      || event.eventType === "lateOrEarly") {
      const matchingShift = statusColor.find(shift => shift.code.includes(event?.statusEn));
      return {
        style: {
          ...baseStyle,
          backgroundColor: matchingShift?.bgColor,
          color: matchingShift?.color,
        }
      };
    }

    if (event.eventType === "overtime") {
      return {
        style: {
          ...baseStyle,
          backgroundColor: "#E1DCF3",
          color: "#6A51C1",
        }
      };
    }

    if (event.eventType === "leave") {
      return {
        style: {
          ...baseStyle,
          backgroundColor: "#FADBEE",
          color: "#E74AAB",
        }
      };
    }

    if (event.eventType === "offsite") {
      return {
        style: {
          ...baseStyle,
          backgroundColor: "#E6F9EB",
          color: "#00BA34",
        }
      };
    }

    if (event.eventType === "seeMore") {
      return {
        style: {
          ...baseStyle,
          backgroundColor: "transparent",
          color: "#969696"
        }
      }
    }

    return null;
  }, [statusColor]);

  const eventWrapper = ({ children, value, style }) => {
    const currentMonth = dayjs(date).month();
    const cellMonth = dayjs(value).month();
    const isCurrentMonth = currentMonth === cellMonth;

    const formattedDate = dayjs(value).format("YYYY-MM-DD");
    const dayData = calendar?.find(o =>
      dayjs(o?.date).format('YYYY-MM-DD') === formattedDate
    );

    const isToday = formattedDate === dayjs().format("YYYY-MM-DD");

    const isHoliday =
      (dayData?.statusEn === "Day Off" || dayData?.holidayName)
    // &&
    // (!dayData?.works || dayData?.works.length === 0);

    const isFirstDayOfWeek = dayjs(value).day() === 0;

    let backgroundColor = '#FFFFFF';
    if (isToday) {
      backgroundColor = '#EAF6FF';
    } else if (isHoliday || !isCurrentMonth) {
      backgroundColor = '#F6F6F6';
    }

    return (
      <div style={{
        ...style,
        position: 'relative',
        height: '100%',
        width: '100%',
        backgroundColor: backgroundColor,
        borderLeft: isFirstDayOfWeek ? 'none' : '1px solid #ddd'
      }}>
        {children}

        {isCurrentMonth && (currentCompanyProfile?.supervisorRequest == "Y") ? (
          <div
            style={{
              position: 'absolute',
              bottom: '4px',
              right: '4px',
              zIndex: 10,
              pointerEvents: 'auto',
              cursor: 'pointer',
              padding: '4px'
            }}
            onClick={(e) => handleEditIconClick(formattedDate, e)}
          >
            <EditOutlined style={{ fontSize: '12px', color: '#999' }} />
          </div>
        ) : null}
      </div>
    );
  };
  function eventOt(doc) {
    let duration = '-';
    let sequence = '-';
    let eventDate = doc.startDate && dayjs(doc.startDate).isValid()
      ? (i18n.language == "en"
        ? dayjs(doc.startDate).format("DD/MM/YYYY")
        : dayjs(doc.startDate).format("DD/MM/BBBB"))
      : '-';
    let requestStatus = '-';
    let badgeText = '-';

    if (doc) {
      console.log("doc doc", doc);

      sequence = doc.sequence || '-';
      requestStatus = doc.approveStatus || '-'

      if (doc.overtimeShiftDetails && Array.isArray(doc.overtimeShiftDetails)) {
        const totalMinutes = doc.overtimeShiftDetails.reduce((sum, detail) => sum + (detail.totalCal || 0), 0);
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;

        if (hours > 0 && minutes > 0) {
          duration = `${hours} ${t("unit.hours")} ${minutes} ${t("unit.minute")}`;
        } else if (hours > 0) {
          duration = `${hours} ${t("unit.hour")}`;
        } else if (minutes > 0) {
          duration = `${minutes} ${t("unit.minute")}`;
        }

        badgeText = doc.overtimeShiftDetails
          .map(detail => i18n.language == "en" ? detail.otCodeNameEn : detail.otCodeName)
          .filter(Boolean)
          .join(', ');
      }
      else if (doc.durationType === "ALLDAY") {
        duration = `${doc.totalDuration} ${t("unit.day")}`;
      } else if (doc.durationType === "HOUR") {

        const totalMinutes = doc.totalDuration || 0;
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;

        if (hours > 0 && minutes > 0) {
          duration = `${hours} ${t("unit.hours")} ${minutes} ${t("unit.minute")}`;
        } else if (hours > 0) {
          duration = `${hours} ${t("unit.hour")}`;
        } else if (minutes > 0) {
          duration = `${minutes} ${t("unit.minute")}`;
        }
      }
    }
    return {
      duration,
      sequence,
      requestStatus,
      badgeText,
      eventDate
    }
  }

  const getPopoverContent = useCallback((event) => {
    const doc = event.leaveDocument?.[0]
      || event.leaveDocumentPending?.[0]
      || event.otDocument
      || event.offSiteDocument
      || event.offSiteWorkDocumentPending;

    let duration = '-';
    let sequence = '-';
    let requestStatus = '-';
    let badgeText = event.titleDetail || '-';
    console.log("doc", doc, event);

    if (doc) {
      sequence = doc.sequence || '-';
      requestStatus = doc.approveStatus || '-'

      if (doc.overtimeShiftDetails && Array.isArray(doc.overtimeShiftDetails)) {
        const totalMinutes = doc.overtimeShiftDetails.reduce((sum, detail) => sum + (detail.totalCal || 0), 0);
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;

        if (hours > 0 && minutes > 0) {
          duration = `${hours} ${t("unit.hours")} ${minutes} ${t("unit.minute")}`;
        } else if (hours > 0) {
          duration = `${hours} ${t("unit.hour")}`;
        } else if (minutes > 0) {
          duration = `${minutes} ${t("unit.minute")}`;
        }

        badgeText = doc.overtimeShiftDetails
          .map(detail => i18n.language == "en" ? detail.otCodeNameEn : detail.otCodeName)
          .filter(Boolean)
          .join(', ');
      }
      else if (doc.durationType === "ALLDAY") {
        duration = `${doc.totalDuration} ${t("unit.day")}`;
      } else if (doc.durationType === "HOUR") {

        const totalMinutes = doc.totalDuration || 0;
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;

        if (hours > 0 && minutes > 0) {
          duration = `${hours} ${t("unit.hours")} ${minutes} ${t("unit.minute")}`;
        } else if (hours > 0) {
          duration = `${hours} ${t("unit.hour")}`;
        } else if (minutes > 0) {
          duration = `${minutes} ${t("unit.minute")}`;
        }
      }
    }

    let badgeColor = "#667085";
    let backgroundColor = "#EAEBEC";

    if (event.eventType === "overtime") {
      badgeColor = "#9333EA";
      backgroundColor = "#F3E8FF";
    } else if (event.eventType === "offsite") {
      badgeColor = "#16A34A";
      backgroundColor = "#DCFCE7";
    } else if (event.eventType === "leave") {
      badgeColor = "#EC4899";
      backgroundColor = "#FCE7F3";
    } else if (event.eventType === "overtimePending" || event.eventType === "leavePending" || event.eventType === "offsitePending") {
      badgeColor = "#FFBF1A";
      backgroundColor = "#FFF8E0";
    }

    const eventDate = event.start && dayjs(event.start).isValid()
      ? (i18n.language == "en"
        ? dayjs(event.start).format("DD/MM/YYYY")
        : dayjs(event.start).format("DD/MM/BBBB"))
      : '-';

    return (
      <Space direction="vertical" style={{ width: "100%" }}>
        <span style={{ color: "#344054", fontSize: "15px" }}>
          {selectedEmployee?.employeeName || employeeName || '-'}
        </span>

        {(doc.overtimeShiftDetails && Array.isArray(doc.overtimeShiftDetails)) ?
          event.otDocumentList.map(o => {
            let data = eventOt(o)
            return <><Badge
              color={badgeColor}
              text={event.eventType === "overtime" || event.eventType === "overtimePending" ? data.badgeText : event.titleDetail}
              style={{ backgroundColor: backgroundColor, borderRadius: "5px", padding: "2px 8px", color: badgeColor, width: "100%" }} /><Flex justify="space-between">
                <span style={{ color: "#667085", borderLeft: "2px solid #757575", paddingLeft: "8px" }}>
                  {data.eventDate}
                </span>
                <span>{data.duration}</span>
              </Flex>
            </>
          }) :

          <>
            <Badge
              color={badgeColor}
              text={event.eventType === "overtime" || event.eventType === "overtimePending" ? badgeText : event.titleDetail}
              style={{ backgroundColor: backgroundColor, borderRadius: "5px", padding: "2px 8px", color: badgeColor, width: "100%" }} />
            <Flex justify="space-between">
              <span style={{ color: "#667085", borderLeft: "2px solid #757575", paddingLeft: "8px" }}>
                {eventDate}
              </span>
              <span>{duration}</span>
            </Flex>
          </>
        }

        <Divider style={{ border: "0.5px solid #ddd", margin: "8px 0px" }} />
        {(doc.overtimeShiftDetails && Array.isArray(doc.overtimeShiftDetails)) ?
          <Flex justify="space-between" align="end">
            <Flex vertical style={{ width: "100%" }}>
              <span style={{ fontSize: "12px", color: "#A0AEC0" }}>{t("expense.expense-detail.request-id")}</span>
              {
                event.otDocumentList.map(o => {
                  requestStatus = o.approveStatus || '-'
                  return <Flex style={{ width: "100%" }} justify="space-between" align="end" vertical={false}>
                    <span>{o?.sequence}</span>
                    <div style={{ height: "max-content" }}>
                      <StatusTag value={requestStatus} />
                    </div>
                  </Flex>
                })
              }
            </Flex>
          </Flex>
          :
          <Flex justify="space-between" align="end">
            <Flex vertical>
              <span style={{ fontSize: "12px", color: "#A0AEC0" }}>{t("expense.expense-detail.request-id")}</span>
              <span>{sequence}</span>
            </Flex>

            <div style={{ height: "max-content" }}>
              <StatusTag value={requestStatus} />
            </div>
          </Flex>
        }
      </Space>
    );
  }, [selectedEmployee?.employeeName, employeeName, i18n.language, t]);

  const handlePopoverVisibleChange = useCallback((eventId, visible) => {
    setPopoverVisible(prev => ({
      ...prev,
      [eventId]: visible
    }));
  }, []);

  return (
    <Space direction="vertical" style={{ width: "100%" }} size={isMobile ? 16 : 24}>
      <SupervisorRequestOtModal
        isOpen={isModalOpen}
        onClose={handleOtModalClose}
        handleOtModalSubmit={handleOtModalSubmit}
        selectedDate={selectedDate}
        selectedEmployee={selectedEmployee}
        employeeName={employeeName}
        workTypeOptions={workTypeOptions}
        onAttachFileChange={onAttachFileChange}
        setpreviousFilew={setpreviousFilew}
        handleOffSiteModalSubmit={handleOffSiteModalSubmit}
        leaveGroupOptions={leaveGroupOptions}
        handleLeaveModalSubmit={handleLeaveModalSubmit}
        selectedDateTime={selectedWorkInTime?.workInStart}
        selectedDateTimeEnd={selectedWorkInTime?.workInEnd}
        selectedOtTime={selectedOtTime?.otTimeStart}
        selectedOtTimeEnd={selectedOtTime?.otTimeEnd}
        editTimeAtt={editTimeAtt}
        selectedShift={selectedShift}
        onSubmit={handleEditWorkTimeModalSubmit}
      />

      <EmployeeWorkinDetailModal
        isLeaveDetailModalOpen={isLeaveDetailModalOpen}
        setIsLeaveDetailModalOpen={setIsLeaveDetailModalOpen}
        selectedDate={selectedDate}
        selectedEmployee={selectedEmployee}
        employeeName={employeeName}
        requests={selectRequest}
      />

      <Flex>
        <Col xs={24} sm={24} md={6} lg={6} style={{ textAlign: "start", alignContent: "center" }}>
          {/* <Button onClick={handleTodayClick} style={{ borderRadius: "8px" }}>{t("units.today")}</Button> */}
          {roles.includes("ROLE_HR") && !isEmployee ?
            <Flex gap={8} align="center">
              <Checkbox
                checked={isHrView}
                onChange={handleHrViewChange}
              />
              <span style={{ fontSize: isMobile ? '13px' : '14px' }}>
                {t("calendar.label.hr_view")}
              </span>
            </Flex>
            : null}
        </Col>
        <Col xs={24} sm={24} md={18} lg={14}>
          <Flex justify="center">
            <LeftArrowIcon onClick={onPrevClick} style={{ cursor: "pointer", alignSelf: "center", width: isMobile ? "6px" : "8px" }} />
            <ConfigProvider theme={{
              components: {
                DatePicker: {
                  colorBgContainer: "transparent"
                }
              }
            }}>
              <DatePicker
                allowClear={false}
                value={dayjs(date)}
                onChange={handleDateChange}
                format={() => view === Views.WEEK
                  ? formattedWeek
                  : dayjs(date).format(i18n.language === "en" ? "MMMM YYYY" : "MMMM BBBB")
                }
                picker={view === Views.WEEK ? "week" : "month"}
                locale={localeFn()}
                suffixIcon={null}
                className={styles.datePicker}
                style={{ width: isMobile ? "150px" : "200px", textAlignLast: "center" }}
              />

            </ConfigProvider>
            <RightArrowIcon onClick={onNextClick} style={{ cursor: "pointer", alignSelf: "center", width: isMobile ? "6px" : "8px" }} />
          </Flex>
        </Col>
        {/* <Col span={9} style={{ alignContent: "center" }}>
          <Flex gap={8} justify="end">
            {currentCompanyProfile?.supervisorRequest == "Y" ?
              <Button
                type="primary"
                style={{ backgroundColor: "var(--button-color)" }}
                onClick={() => {
                  setIsUpdateMode((prevMode) => !prevMode);
                }}
              >
                {isUpdateMode ? t("calendar.label.cancel_ot_work") : t("calendar.label.ot_work")}
              </Button>
              : null} */}
        {/* <Radio.Group
              value={view}
              onChange={handleViewChange}
              optionType="button"
              buttonStyle="outline"
            >
              <Radio.Button value={Views.MONTH}>{t("unit.month")}</Radio.Button>
              <Radio.Button value={Views.WEEK}>{t("unit.week")}</Radio.Button>
            </Radio.Group> */}
        {/* </Flex>
        </Col> */}
      </Flex>

      <div className={styles.calendarContainer}>
        <div className={styles.calendarWrapper}>
          <Calendar
            localizer={localizer}
            events={processedEvents}
            startAccessor="start"
            endAccessor="end"
            style={{
              minHeight: isMobile ? "500px" : "600px",
              width: "100%",
              fontSize: isMobile ? "12px" : "14px"
            }}
            view={view}
            onView={handleViewDateChange}
            date={date}
            onNavigate={setDate}
            dayPropGetter={dayPropGetter}
            eventPropGetter={eventPropGetter}
            // onSelectSlot={handleSelectSlot}
            onSelectEvent={handleSelectEvent}
            // selectable={isUpdateMode}
            components={{
              event: ({ event }) => {
                const clickableEventTypes = ['leave', 'leavePending', 'overtime', 'overtimePending', 'offsite', 'offsitePending'];
                const eventId = `${event.eventType}-${dayjs(event.start).format('YYYY-MM-DD')}`;
                console.log("event", event);

                if (clickableEventTypes.includes(event.eventType)) {
                  return (
                    <Popover
                      content={getPopoverContent(event)}
                      title={null}
                      trigger="click"
                      open={popoverVisible[eventId]}
                      onOpenChange={(visible) => handlePopoverVisibleChange(eventId, visible)}
                      placement="top"
                      overlayStyle={{ width: '300px' }}
                      overlayInnerStyle={{ width: '100%' }}
                    >
                      <span style={{ cursor: 'pointer' }}>
                        {view === Views.MONTH ? event.titleMonth : event.titleDetail}
                      </span>
                    </Popover>
                  );
                }

                return <span>{view === Views.MONTH ? event.titleMonth : event.titleDetail}</span>;
              },
              dateCellWrapper: eventWrapper
            }}
            toolbar={false}
          />
          {footerTag()}
        </div>
      </div>
    </Space>
  );
}

export default EmployeeWorkInCalendar;
